<script lang="ts">import { testimonialsData } from "../data";
import Testimonials from "../icons/testimonials.png";
import { getVerbiageKey } from "../utils";
import { stateUi } from "@infinitro/config";
import { t, Verbiage } from "@infinitro/content";
import { InfoCard } from "@infinitro/info-card";
import { Text } from "@infinitro/text";
import { onDestroy, onMount } from "svelte";
import Swiper from "swiper";
import { EffectCoverflow } from "swiper/modules";
import "swiper/swiper-bundle.css";
let swiperContainer;
let swiper;
$: useHeadlineHeader = $stateUi.vip.testimonialsHeaderStyle === "headline";
$: useCompactTestimonialsCardHeight = $stateUi.vip.useCompactTestimonialsCardHeight ?? false;
onMount(() => {
	Swiper.use([EffectCoverflow]);
	swiper = new Swiper(swiperContainer, {
		slidesPerView: 1.2,
		slideNextClass: "swiper-slide-next",
		slidePrevClass: "swiper-slide-prev",
		spaceBetween: 30,
		loop: true,
		effect: "coverflow",
		grabCursor: true,
		touchEventsTarget: "container",
		centeredSlides: true,
		coverflowEffect: {
			rotate: 0,
			stretch: 0,
			depth: 100,
			modifier: 1,
			slideShadows: false
		}
	});
});
onDestroy(() => {
	if (swiper) swiper.destroy(true, true);
});
</script>

<div class="vip-testimonials">
	{#if useHeadlineHeader}
		<div class="title-wrap--headline">
			<h1>
				{$t(Verbiage[getVerbiageKey('vip_testimonials_text')])}
			</h1>
		</div>
	{:else}
		<div class="testimonials-badge">
			<img src={Testimonials} alt={$t(Verbiage.testimonials_icon_alt, 'alts')} />
			<Text type="body" bodySize="small">{$t(Verbiage[getVerbiageKey('testimonials_text')])}</Text>
		</div>
		<Text type="title" titleSize="h3" textAlign="center"
			>{$t(Verbiage[getVerbiageKey('vip_testimonials_text')])}</Text
		>
	{/if}
	<div class="testimonials-desktop">
		{#each testimonialsData as testimonial, index}
			<div
				class:justify-start-card={useHeadlineHeader}
				class={index === 0 || index === 1 ? 'justify-end-card' : 'justify-start-card'}
			>
				<InfoCard width="100%" height="fit-content">
					<div
						class:testimonial-card--compact={useCompactTestimonialsCardHeight}
						class="testimonial-card"
					>
						<div class="testimonial-name">
							<img src={testimonial.avatar} alt={$t(Verbiage.avatar_alt, 'alts')} />
							<Text type="body" bodySize="large">{testimonial.name}</Text>
						</div>
						<Text type="body" bodySize="medium" textColor="gray" customStyle="line-height: 2rem;"
							>{$t(Verbiage[testimonial.testimonial])}</Text
						>
					</div>
				</InfoCard>
			</div>
		{/each}
	</div>
	<div class="testimonials-mobile">
		<div class="swiper swiper-testimonials" bind:this={swiperContainer}>
			<div class="swiper-wrapper">
				{#each testimonialsData as testimonial, index}
					<div class="swiper-slide custom-slide">
						<InfoCard width="100%" height="fit-content">
							<div class="testimonial-card">
								<div class="testimonial-name">
									<img src={testimonial.avatar} alt={$t(Verbiage.avatar_alt, 'alts')} />
									<Text type="body" bodySize="large">{testimonial.name}</Text>
								</div>
								<Text
									type="body"
									bodySize="medium"
									textColor="gray"
									customStyle="line-height: 2rem;">{$t(Verbiage[testimonial.testimonial])}</Text
								>
							</div>
						</InfoCard>
					</div>
				{/each}
			</div>
		</div>
	</div>
</div>

<style>
	.title-wrap--headline {
		margin-top: 3rem;
		width: 100%;
		padding-left: 1rem;
		padding-right: 1rem;
		--tw-text-opacity: 1;
		color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
	.title-wrap--headline h1 {
		font-size: 28px;
		font-weight: 600;
		line-height: 28px;
		letter-spacing: 1px;
}
	.title-wrap--headline h2 {
		margin-bottom: 0.75rem;
		font-size: 0.875rem;
		line-height: 1.25rem;
}

	.vip-testimonials {
		display: flex;
		width: 100%;
		flex-direction: column;
		align-items: center;
		gap: 0.75rem;
}

	.testimonials-badge {
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 0.25rem;
		border-radius: 9999px;
		padding-left: 1rem;
		padding-right: 1rem;
		padding-top: 0.25rem;
		padding-bottom: 0.25rem;
		background: var(--gradient-main);
}

	.testimonials-desktop {
		margin-top: 1rem;
		display: none;
		width: 100%;
		align-items: center;
}
	@media (min-width: 1024px) {
		.testimonials-desktop {
				display: grid;
				grid-template-columns: repeat(2, minmax(0, 1fr));
				gap: 1.5rem;
		}
	}

	.testimonials-mobile {
		display: block;
		width: 100%;
		padding-top: 1rem;
		padding-bottom: 1rem;
}
	@media (min-width: 1024px) {
		.testimonials-mobile {
				display: none;
		}
	}

	.testimonial-name {
		margin-bottom: 0.5rem;
		display: flex;
		align-items: center;
		gap: 0.5rem;
}

	.testimonial-card {
		display: flex;
		height: 100%;
		flex-direction: column;
		gap: 0.5rem;
}
	@media (min-width: 1024px) {
		.testimonial-card {
				height: 200px;
		}
		.testimonial-card--compact {
				height: auto;
		}
	}

	.justify-end-card {
		display: flex;
		height: 100%;
		flex-direction: column;
		justify-content: flex-end;
}

	.justify-start-card {
		display: flex;
		height: 100%;
		flex-direction: column;
		justify-content: flex-start;
}

	.custom-slide {
		display: flex;
		height: 500px;
		align-items: center;
		justify-content: center;
}

	:global(.swiper-testimonials .swiper-slide-prev) {
		opacity: 0.5 !important;
	}

	:global(.swiper-testimonials .swiper-slide-next) {
		opacity: 0.5 !important;
	}

	:global(.swiper-slide-active) {
		opacity: 1 !important;
	}
</style>
